import React from "react";
import Select from "react-select";

const SelectInputSearch = ({
  id,
  label,
  onChange,
  name,
  error,
  optionsSelect,
  placeholder,
  value,
  minWidth,
}) => {
  let invalidT = "form-control";
  if (error) {
    invalidT += " is-invalid";
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "none",
      borderRadius: "0.25rem",
      boxShadow: "none",
      minWidth: minWidth,
      marginTop: 0,
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: 0,
    }),
    container: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided) => ({
      ...provided,
      color: "#000000",
    }),
  };

  return (
    <>
      <Select
        id={id}
        name={name}
        className={invalidT}
        styles={customStyles}
        onChange={onChange}
        options={optionsSelect}
        isSearchable={true}
        value={optionsSelect.find((option) => option.value === value) || value}
        placeholder={placeholder}
      />
      {error !== 0 && (
        <div
          className="mb-1"
          style={{
            marginTop: "0.25rem",
            fontSize: "80%",
            color: "#dc3545",
          }}
        >
          {error}
        </div>
      )}
    </>
  );
};

export default SelectInputSearch;
